export default "__VITE_ASSET__B5Ah1$FT__"